import { RouteConfig } from 'vue-router';
import { AdminRoles } from '@/configs/role';

const progressRoutes: RouteConfig = {
  path: 'progress',
  component: () => import(/* webpackChunkName: 'dashboard.progress' */ '@/pages/progress/Index.vue'),
  redirect: {
    name: 'progress-list',
  },
  children: [
    {
      path: 'project/:projectId/list',
      name: 'progress-list',
      component: () => import(/* webpackChunkName: 'dashboard.progress' */ '@/pages/progress/List.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
    {
      path: 'project/:projectId/sms/:progressId',
      name: 'progress-sms-log',
      component: () => import(/* webpackChunkName: 'dashboard.progress' */ '@/pages/progress/Sms.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
    {
      path: 'project/:projectId/create',
      name: 'progress-create',
      component: () => import(/* webpackChunkName: 'dashboard.progress' */ '@/pages/progress/Edit.vue'),
      meta: {
        action: 'create',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
    {
      path: 'project/:projectId/:progressId/edit',
      name: 'progress-edit',
      component: () => import(/* webpackChunkName: 'dashboard.progress' */ '@/pages/progress/Edit.vue'),
      meta: {
        action: 'edit',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
  ],
};

export default progressRoutes;
